import React from 'react';
import { HomeIcon, BuildingOfficeIcon, BuildingOffice2Icon } from '@heroicons/react/24/outline';
import { Container } from '../common/Container';

const propertyTypes = [
  { Icon: HomeIcon, title: 'Residential', detail: 'High-volume portfolio workflows' },
  { Icon: BuildingOfficeIcon, title: 'Commercial', detail: 'Complex valuation and appeal records' },
  { Icon: BuildingOffice2Icon, title: 'Condominiums', detail: 'Building and unit-level tracking' },
];

export const PropertyTypes: React.FC = () => {
  return (
    <section className="bg-white py-20">
      <Container>
        <div className="flex flex-col justify-between gap-5 border-b border-gray-200 pb-8 md:flex-row md:items-end">
          <h2 className="text-3xl font-bold tracking-tight text-brand-blue">Built for your portfolio.</h2>
          <p className="text-brand-white-700">Residential, commercial, and condominium appeals.</p>
        </div>
        <div className="grid md:grid-cols-3">
          {propertyTypes.map((type, index) => (
            <div key={type.title} className={`flex items-center gap-4 py-8 md:px-7 ${index < 2 ? 'border-b border-gray-200 md:border-b-0 md:border-r' : ''} ${index === 0 ? 'md:pl-0' : ''}`}>
              <type.Icon className="h-8 w-8 flex-shrink-0 text-brand-red" />
              <div>
                <h3 className="text-xl font-bold text-brand-blue">{type.title}</h3>
                <p className="mt-1 text-sm text-brand-white-700">{type.detail}</p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};
